
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'
import { sort, sortSev, getByType, beautifyPhone } from 'utils/stuff'

import Divider from 'material-ui/Divider'
import Colors from 'material-ui/styles/colors'
import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'

import dataActions from 'actions/dataActions'
import AttachmentCard from 'components/Attachments/AttachmentCard'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import Error from 'components/Error'
import Deleted from 'components/Deleted'
import newCommentActions from 'actions/newCommentActions'
import InputPhone from 'components/InputPhone'
import {Tabs, Tab} from 'material-ui/Tabs'
import attachmentActions from 'actions/attachmentActions'

import LeftNav from 'material-ui/Drawer'
import LeftNavMenu from 'components/LeftNavMenu'
import actionBarActions from 'actions/actionbar'


import { managers, bills, properties, owners } from 'selectors/entities'
import { managerAvatar } from 'selectors/attachments'

let select = (state, props) => ({
	...state
  ,  managers: managers(state)
  ,  bills: bills(state)
	, properties: properties(state)
	, owners: owners(state)
  , managerAvatar: managerAvatar(state, props.id || props.routeParams.id)
})

const books = {
	"1475497398261": "Saltovka LLC",
	"1476645611177": "401K Natalie & Sergey",
	"1476645633015": "Bavaria LLC",
	"1476645653317": "LuMand Properties",
	"1476645781766": "401K Kharkov LLC",
	"1476645789362": "401K Bakunina LLC",
	"1476646019599": "Boris Fuksshimov",
	"1492167277719": "Alekseevka",
	"1488554953604": "GSA Pension Plan",
	"1492167481279": "Levada",
	"1492167305879": "Novoselovka",
	"1492167290119": "Odesskay",
	"1492167256488": "Osnova"
}

export class Manager extends Component{
	constructor(props){
		super(props)
		let managerID = props.id || props.routeParams.id
		this.state ={
			cellNumber: {
				value: (props.managers[managerID])? props.managers[managerID].cellNumber : undefined
			  , selectionStart: undefined
			}
		}
	}
	componentWillUpdate(){
		let managerID = this.props.id || this.props.routeParams.id
		if(this.props.managers[managerID] && typeof this.state.cellNumber.value != "string"){
			this.setState({
				cellNumber: {
					value: this.props.managers[managerID].cellNumber || ""
				}
			})
		}
	}

	bill3days = (o) => {
		let ret = []
		for (var key in o) {
			var bill = o[key]
			if (new Date().valueOf() - new Date(bill.date).valueOf() < 2678400000){
					ret.push(bill)
					console.log(bill);
				}
		}
		console.log("UNSORTED:", ret);
		ret.sort(function(a, b) {
			return new Date(b.date).valueOf() - new Date(a.date).valueOf()
		})
		console.log(ret);
		return ret
	}

	render(){

		try {
			let properties = this.props.properties
			let owners = this.props.owners
			let managerID = this.props.id || this.props.routeParams.id
			var isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)
			let isMe = (this.props.managers[managerID])? this.props.session.username.toLowerCase() == this.props.managers[managerID].name.toLowerCase(): false
			return(
				<div>
					<header
						style={{
							width: "100%"
						  , height: "60px"
						  , top: "0"
						  , zIndex: "5555"
						  , backgroundColor: "#00ACC1"
						  , position: "fixed"
						  , lineHeight: "60px"
						  , paddingTop: "0"
						  , borderBottom: "1px solid #e1e3e2"
						  , paddingLeft: "12px"
						}}
						className="action-bar form-holder"
					>
							{(typeof global.md.phone() == 'string')?
								<div
									style={{
										width: "inherit"
									  , height: "inherit"
									}}
								>
									<img
										src={"/manager/static/img/hamburger.png"}
										style={{
											maxHeight: "20%"
										  , verticalAlign: "middle"
										  , marginLeft: "21px"
										}}
										onTouchTap={this.props.TOOGLE_LEFT_NAV}
									/>
									<span
										style={{
											overflow: "hidden"
										  , textOverflow: "ellipsis"
										  , whiteSpace: "nowrap"
										  , display: "inline-block"
										  , width: "50%"
										  , verticalAlign: "middle"
										  , marginLeft: "8%"
										}}
									>
										{(this.props.managers[managerID])? this.props.managers[managerID].firstName : ""}
									</span>
									<div
										style={{
											float: "right"
										  , width: "15%"
										  , textAlign: "right"
										  , height: "inherit"
										}}
									>
									</div>
								</div>
								:
									<div id="close-project-specs"
										style={{
											lineHeight: "60px"
										}}
									>
										<svg
											width="17px"
											height="17px"
											viewBox="0 0 17 17"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											style={{
												verticalAlign: "middle"
											  , marginLeft: "12px"
											  , cursor: "pointer"
											}}
											onClick={()=>{
												this.props.goBack()
											}}
										>
										    <title>Group</title>
										    <defs></defs>
										    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
										        <g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
										        </g>
										    </g>
										</svg>
										<span
											style={{
												fontSize: "24px"
											  , marginTop: "0px"
											  , marginLeft: "10px"
											  , verticalAlign: 'middle'
											  , display: "inline-block"
											  , width: "calc(100% - 29px - 50px)"
											  , textAlign: "left"
											}}
										>
											{(this.props.managers[managerID])?this.props.managers[managerID].name:""}
										</span>
									</div>
							}

					</header>
					{(!this.props.managers[managerID])?
						<Deleted />
						:<Tabs
  							inkBarStyle={{backgroundColor: "#23987c"}}
  							tabItemContainerStyle={{backgroundColor: "#3cd2ae"}}
  							style={{
  								marginTop: "61px"
  							}}
  						>
  							<Tab label="GENERAL">
								<div
									style={{
											maxWidth: (this.props.id)? 'auto' : '800px'
										  , margin: "auto"
										  , overflow: (isMob)? "auto" : 'hidden'
										  , paddingRight: (isMob)? "0" : "16px"
										  , paddingLeft: (isMob)? "0" : "24px"
										  , paddingTop: (isMob)? "0" : "24px"
										  , ...this.props.style
									}}
									speed={0.8}
									className="area"
									contentClassName="content"
									horizontal={false}
									verticalScrollbarStyle={{
										width: "16px"
									  , borderRadius: "13px"
									  , marginLeft: "1px"
									  , backgroundImage: "url(/assets/manager/img/bar.png)"
									  , backgroundSize: "100%"
									  , backgroundRepeat: "no-repeat"
									  , backgroundColor: "#f5f6f5"
									  , backgroundPosition: "center"
									  , display: (isMob)? "none" :"auto"
									}}
									minScrollSize={30}
									verticalContainerStyle={{
										width: "18px"
									  , backgroundColor: "#cdcdcd"
									  , opacity: "1"
									  , display: (isMob)? "none" :"auto"
									}}
									// ref="right-panel"
									className={(typeof global.md.phone() == 'string')? "mobile-right-panel": ""}
								>
									<div>
										{(isMe)?
											<input
												type="file"
												style={{
													height: '40px'
												  , width: '30px'
												  , display: 'none'
												  , cursor: 'pointer'
												}}
												onChange={(evt) =>{
													let attID = new Date().valueOf().toString()
													if(!~evt.target.files[0].type.indexOf('image')) return false
													if(evt.target.files[0]){
														this.props.DOC_UPDATE({
															_id: managerID
														  , _attachments: {
																[attID]:{
																	data: evt.target.files[0]
																  , content_type: evt.target.files[0].type
																}
															}
														  , avatar: attID
														})
													}
												}}
												ref={"choose-avatar"}
												title="Choose avatar"
											/>
											:""
										}
										{(this.props.managerAvatar)?
											<div className="avatar-holder">
												{(isMe)?
													<div style={{float: "right", position: "relative", left: "-25px"}}>
														<img src={".." + "/static/img/pencil-edit.png"}
															onClick={
																()=>{
																	this.refs["choose-avatar"].click()
																}
															}
															style={{
																width: "20px",
																cursor: "pointer",
																borderColor: "#A0A0A0"
															}}
														/>
													</div>
													: ""
												}
												<AttachmentCard
													attachmentID={this.props.managerAvatar._id}
													avatar={true}
													avatarStyle={{
														width: "100px"
													  , height: "100px"
													  , overflow: "hidden"
													  , borderRadius: "100%"
													  , display: "inline-block"
													  , float: "left"
													  , margin: "0 26px 0 13px"
													}}
												/>
											</div>
											:<div className="avatar-holder">
												{(isMe)?
													<div style={{float: "right", position: "relative", left: "-25px"}}>
														<img src={".." + "/static/img/pencil-edit.png"}
															onClick={
																()=>{
																	this.refs["choose-avatar"].click()
																}
															}
															style={{
																width: "20px",
																cursor: "pointer",
																borderColor: "#A0A0A0"
															}}
														/>
													</div>
													: ""
												}
												<img className="material-icons"
													style={{
														overflow: 'hidden'
													  , display: 'block'
													  , textAlign: 'center'
													  , margin: '0 5px'
													  , verticalAlign: 'top'
													  ,width: '150px'
													  , height:'150px'
													  , display: 'inline-block'
													  , margin: 'auto'
													  , borderRadius: "100px"
													}}
													src={"/manager/static/img/svg-icon/managers_green.svg"}
												/>
											</div>
										}
									</div>
									<div style={{clear: "both", marginTop: "64px"}}>
										<i
											className="material-icons"
											style={{
												marginLeft: (typeof global.md.phone() != 'string')? "10px" : ""
												, paddingTop: "0px"
												, color: "#4ad4b2"
												, marginRight: "6px"
												, float: "left"
												, fontSize: "20px"
												, position: "relative"
												, top: "-24px"
											}}
										>
											call
										</i>
										<InputPhone className={(isMe)?"":"no-underline"}
											style={{width: (isMob)?"calc(100% - 40px)":"370px", position: "relative", left: (isMob)?"32px":"40px", top: "-57px", marginBottom:"-40px"}}
											value={this.props.managers[managerID].cellNumber}
											disabled={!isMe}
											key={`${managerID}-phone`}
											ref={`cellNumber-${managerID}`}
											hintText={(isMe)?"Enter your phone":"No phone"}
											hintStyle={{fontSize: "14px", fontStyle: "italic"}}
											underlineStyle={{borderBottom: "0px solid"}}
											inputStyle={{fontSize: "14", color: '#000'}}
											onBlur={(newValue) =>
												(newValue.length)?
													this.props.DOC_UPDATE({
														_id: managerID
													  , cellNumber: newValue
													})
													: false}
										/>

									</div>
									<div>
										<i
											className="material-icons"
											style={{
												marginLeft: (typeof global.md.phone() != 'string')? "10px" : ""
												, marginTop: "14px"
												, color: "#4ad4b2"
												, marginRight: "10px"
												, clear: "both"
												, float: "left"
												, fontSize: "20px"
												, position: "relative"
												, top: "-22px"
											}}
										>
											email
										</i>
										<TextField className={(isMe)?"":"no-underline"}
											style={{width: (isMob)?"calc(100% - 40px)":"370px", position: "relative", top:"-22px"}}
											defaultValue={this.props.managers[managerID].email}
											disabled={!isMe}
											key={`${managerID}-email`}
											hintText={(isMe)?"Enter your email":"No email"}
											hintStyle={{fontSize: "14px", fontStyle: "italic"}}
											underlineStyle={{borderBottom: "0px solid"}}
											inputStyle={{fontSize: "14", color: '#000'}}
											onBlur={(evt)=> (evt.target.value.length)? this.props.DOC_UPDATE({_id: managerID, email: evt.target.value}): false}
										/>

									</div>
									<div>
										<TextField className={(isMe)?"":"no-underline"}
											key={`${managerID}-note`}
											style={{marginLeft: "12px", width: "calc(100% - 32px)"}}
											multiLine={true}
											defaultValue={this.props.managers[managerID].note}
											hintText={(isMe)?"About me":""}
											hintStyle={{fontSize: "14px", fontStyle: "italic"}}
											underlineStyle={{borderBottom: "0px solid"}}
											disabled={!isMe}
											inputStyle={{fontSize: "16", color: '#000'}}
											onBlur={(evt)=> this.props.DOC_UPDATE({_id: managerID, note: evt.target.value})}
										/>

									</div>
									<Divider/>

									<div style={{display: isMe? "": "none"}}>
										<p style={{textAlign: "center", fontWeight: "bold", marginBottom: "0px"}}>RECENTLY ENTERED BILLS:</p>
										<table style={{fontSize: "14px", width: "100%"}}><tbody>
										{
											R.map((bill) =>
												(bill ?
														<tr key = {bill._id}>
															<td style={{width: "20px"}}>
																<Link
																	to={`/manager/transactions/${bill._id}/`}
																	style={{
																		textDecoration: 'none'
																	}}
																>
																	<img src={bill.qbid || bill.qbidNew ? "/manager/static/img/qb-green.png" : "/manager/static/img/qb-gray.png"}
																		style={{width: "14px", marginTop: "3px"}}
																	/>
															</Link>
															</td>
															<td style={{width: "50px"}}>
																{`${bill.dueDate.slice(5,7)}/${bill.dueDate.slice(8,10)}`}
															</td>
															<td style={{width: "160px", maxWidth: "160px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>
																{bill.propertyID && owners[properties[bill.propertyID].ownerID]?
																	owners[properties[bill.propertyID].ownerID].qbbookNew == 'kg' ?
																		`KG: ${owners[properties[bill.propertyID].ownerID].llc}`
																		:
																		`${owners[properties[bill.propertyID].ownerID].firstName}`
																	:
																	'No propertyID'
																}
															</td>
															<td style={{maxWidth: "180px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>
																{bill.vendor}
															</td>
															<td style={{width: "80px", textDecoration: bill.isPaid && bill.isPaid.toString()=="true" ? "line-through" : "none"}}>
																${bill.amount}
															</td>
														</tr>
														:""
											), this.bill3days(this.props.bills))
										}
										</tbody></table>
									</div>
								</div>
							</Tab>
						</Tabs>

					}
				</div>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([dataActions, attachmentActions, attachmentOverlayActions, newCommentActions, rightStackActions, actionBarActions]))(Manager)



// WEBPACK FOOTER //
// ./src/routes/manager/managerForm/index.js